var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDascamNavIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3426 42.5234C22.9625 42.5579 22.7207 42.627 22.4788 42.627C18.7473 42.5925 14.9812 42.6961 11.2496 42.3852C8.69282 42.1779 6.10147 41.5905 3.64832 40.7958C0.746012 39.8975 -0.152324 38.2736 0.0204328 35.3712C0.124087 33.5055 1.36794 32.2962 2.68089 31.1905C5.23769 29.0483 8.24365 27.6317 11.3187 26.4224C13.1845 25.6969 13.841 24.2457 13.1499 22.4145C12.9772 21.9999 12.6317 21.6544 12.3553 21.2743C9.07289 16.8517 7.75994 11.9454 9.14199 6.55542C10.3513 1.96009 14.532 -0.527609 19.2655 0.0943157C23.7918 0.647137 26.7286 4.13682 27.1432 8.52485C27.627 13.4311 26.3486 17.7846 23.2389 21.6198C22.5134 22.4836 22.5825 23.4856 22.5479 24.5221C22.5479 24.9713 22.4443 25.455 22.237 25.8351C18.8509 31.2251 19.1619 37.1334 23.1353 42.1433C23.1698 42.1779 23.2044 42.2815 23.3426 42.5234Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0422 37.4799L26.2109 38.4128V34.9922C26.591 35.9596 27.2475 36.8234 28.0422 37.4799Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2109 29.946V26.5254L28.0422 27.4583C27.2475 28.1493 26.591 29.0131 26.2109 29.946Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2109 32.953V31.9855C26.3491 30.2925 27.1784 28.7377 28.5259 27.7012L28.975 27.9085C27.2129 30.7071 27.2129 34.2314 28.975 37.0646L28.5259 37.2719C27.1438 36.2008 26.3146 34.6805 26.2109 32.953Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2178 27.5282L28.9414 27.39C29.2178 27.2172 29.5288 27.0445 29.8052 26.9062C29.5979 27.079 29.3906 27.3209 29.2178 27.5282Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8052 38.0653C29.4942 37.9271 29.2178 37.7889 28.9414 37.5816L29.2178 37.4434C29.4251 37.6507 29.5979 37.858 29.8052 38.0653Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4584 37.8242C28.873 38.1352 29.3567 38.377 29.8059 38.5498H26.9727L28.4584 37.8242Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4584 27.1475L26.9727 26.4219H29.8059C29.3221 26.5946 28.873 26.8365 28.4584 27.1475Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3532 28.1152L30.2516 28.5644C29.6642 31.1212 29.6642 33.8162 30.2516 36.373L29.3532 36.8222C27.6948 34.1617 27.6948 30.7757 29.3532 28.1152Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3896 36.8574C30.5278 37.3757 30.8043 37.894 31.1152 38.3431C30.5278 38.1013 30.0441 37.7212 29.6641 37.2375L30.3896 36.8574Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6641 27.7346C30.0441 27.2508 30.5624 26.8708 31.1152 26.6289C30.8043 27.0781 30.5624 27.5963 30.3896 28.1146L29.6641 27.7346Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9089 28.0809C31.2199 27.1826 31.6345 26.6298 32.0146 26.457V28.9447L30.8398 28.3228C30.8744 28.2537 30.8744 28.15 30.9089 28.0809Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6998 36.1661C30.4234 34.9568 30.2852 33.7129 30.2852 32.4691C30.2852 31.2252 30.4234 29.9814 30.6998 28.8066L32.0127 29.4631V35.5096L30.6998 36.1661Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8398 36.6493L32.0146 36.0273V38.515C31.6 38.3423 31.2199 37.7549 30.9089 36.8911C30.9089 36.822 30.8744 36.7184 30.8398 36.6493Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0548 29.9461L32.5 29.1514V26.4219C32.9146 26.5946 33.2947 27.182 33.6056 28.0458C33.813 28.6677 33.9512 29.3242 34.0548 29.9461Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 38.5164V35.7869L34.0548 34.9922C33.9512 35.6141 33.813 36.236 33.6056 36.858C33.2947 37.7908 32.9146 38.3782 32.5 38.5164Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1591 34.4386L32.5352 35.2678V29.7051L34.1591 30.5343C34.2282 31.1908 34.2627 31.8473 34.2627 32.5037C34.2627 33.1257 34.2282 33.8167 34.1591 34.4386Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.332 33.8848C35.9865 36.0269 34.8463 37.72 33.4297 38.3419C33.9825 37.6163 34.3971 36.3379 34.6044 34.7485L36.332 33.8848Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6044 30.2222C34.3971 28.6329 33.9825 27.389 33.4297 26.6289C34.8808 27.2163 35.9865 28.9438 36.332 31.086L34.6044 30.2222Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6406 34.1966C34.6752 33.6438 34.7097 33.0909 34.7097 32.5036C34.7097 31.9162 34.6752 31.3288 34.6406 30.8105L36.4027 31.7089C36.4373 31.9507 36.4373 32.2272 36.4373 32.5036C36.4373 32.78 36.4027 33.0564 36.4027 33.3328L34.6406 34.1966Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8867 33.0556C36.8867 32.8828 36.8867 32.6755 36.8867 32.4682C36.8867 32.2609 36.8867 32.0882 36.8867 31.8809L38.0615 32.4682L36.8867 33.0556Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8531 33.6097L38.3388 32.8496C38.2006 35.13 36.784 37.0994 34.7109 38.0323C35.8166 37.0649 36.6113 35.4755 36.8531 33.6097Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7109 26.9062C36.784 27.8046 38.2006 29.8431 38.3388 32.089L36.8531 31.3288C36.6113 29.463 35.8166 27.8737 34.7109 26.9062Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7109 26.3867H38.3388V30.0146C37.6824 28.3561 36.3694 27.0432 34.7109 26.3867Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3382 34.9551V38.583H34.6758C36.3688 37.9265 37.6817 36.6135 38.3382 34.9551Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.257 22.4141C26.6942 22.4141 22.168 26.9403 22.168 32.5031C22.168 38.0658 26.6942 42.5921 32.257 42.5921C37.8197 42.5921 42.346 38.0658 42.346 32.5031C42.346 26.9057 37.8197 22.4141 32.257 22.4141ZM38.8217 39.0678H25.6922V25.9037H38.8217V39.0678Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDascamNavIcon3);
export default __webpack_public_path__ + "static/media/dascamNavIcon3.e69542277b822548d0228efa663bd3d4.svg";
export { ForwardRef as ReactComponent };